import React, { Suspense, useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { itemHelper } from '../../common/src/helpers'
import { isInitializedRequestForPMResource } from '../../common/src/selectors/requestStateSelectors'
import { PM_API_RESOURCES } from '../../common/src/constants'
import { Loading } from '../../components/basic/Loading'
import { useRandomValueFromArray } from '../../hooks/arrayHooks'
import { isEmbeddedOnTeams } from '../../helpers/queryParamsHelper'
import { BasicItemList } from '../../components/item/basicList/BasicItemList'
import { useTranslatedPlaceholders } from '../../hooks/translationHooks'
import { LazyIViewPlaceholder } from '../../components/placeholder/LazyIViewPlaceholder'
import { useSelectedItemId } from '../../hooks/PMHooks'
import { useAttentionNeededQuery } from '@/queries/items'

const HomeAlerts_ = ({ onSelectItem, items, setForceAlertId }) => {
  useAttentionNeededQuery()
  const loading = useSelector(state => !isInitializedRequestForPMResource(state, PM_API_RESOURCES.ATTENTION_NEEDED))
  const selectedItemId = useSelectedItemId()

  // Hack: Virtualized list doesn't guess the parent height in the first render, so we force it to re-render:
  // TODO try to remove this
  const [forceUpdate, setForceUpdate] = useState(0)
  useEffect(() => {
    setForceUpdate(value => value + 1)
  }, [])

  const allPlaceholders = useTranslatedPlaceholders('alerts.placeholder_', 7)
  allPlaceholders[6].type = 3
  const validPlaceholders = useMemo(() => {
    return !isEmbeddedOnTeams() ? allPlaceholders.slice(0, -1) : allPlaceholders
  }, [allPlaceholders])
  const placeholder = useRandomValueFromArray(validPlaceholders)

  const customOnSelectItem = useCallback(
    (item, idx) => {
      const id = itemHelper.getId(item)
      setForceAlertId(id)
      onSelectItem(item)
    },
    [setForceAlertId, onSelectItem]
  )

  if (!loading && !items.length) {
    return (
      <Suspense fallback={<Loading />}>
        <LazyIViewPlaceholder {...placeholder} />
      </Suspense>
    )
  }

  return (
    <BasicItemList
      items={items}
      selectedItemId={selectedItemId}
      onClickItem={customOnSelectItem}
      loading={loading}
      shouldShowProject
      key={forceUpdate}
    />
  )
}

export const HomeAlerts = React.memo(HomeAlerts_)
